import { createUseStyles } from 'react-jss';
import {
  BackgroundColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Easings } from '@picsart/design-system/foundation/easings';
import { canHover } from '@picsart/design-system/styleUtils/hoverTouch';

const useStyles = createUseStyles(
  {
    modal: {
      backgroundColor: BackgroundColors.base,
      borderRadius: CornerRadius.r16,
      width: 'auto',
      minWidth: 280,
      maxWidth: 560,
      maxHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: [Spacings.s16, Spacings.s16],
      borderBottom: [1, 'solid', BackgroundColors.tint3],
    },
    title: {
      fontSize: FontSizes.t5,
      fontWeight: FontWeights.semibold,
      color: TextColors.base,
      margin: 0,
    },
    content: {
      flex: 1,
      overflowY: 'auto',
      padding: Spacings.s16,
    },
    grid: {
      display: 'grid',
      gap: Spacings.s12,
      // Column count set dynamically based on image count
    },
    gridSingle: {
      gridTemplateColumns: '1fr',
    },
    gridMultiple: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    imageItem: {
      aspectRatio: '1',
      borderRadius: CornerRadius.r12,
      overflow: 'hidden',
      cursor: 'pointer',
      border: [2, 'solid', 'transparent'],
      transition: `all 0.15s ${Easings.ease}`,
      backgroundColor: BackgroundColors.tint2,
      // Base size for grid items
      width: 240,
      height: 240,
      [canHover]: {
        '&:hover': {
          border: [2, 'solid', TextColors.tint1],
          transform: 'scale(1.02)',
        },
      },
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    emptyState: {
      textAlign: 'center',
      padding: [Spacings.s24, Spacings.s16],
      color: TextColors.tint1,
      fontSize: FontSizes.t4,
    },
  },
  { name: 'canvas-image-selector' }
);

export default useStyles;
